(function () {
  let baseUrl = "https://saltandpepper.com.au/apps/connector";
  if (Shopify?.shop.includes('staging')) {
    baseUrl = "https://salt-and-pepper-au-staging.myshopify.com/apps/connector";
  }
  const endpoints = {
    updateCart: "api-promotionUpdateCart",
    checkout: "api-promotionGetCheckout",
    markdown: "api-promotionMarkdown",
  };

  const request = async (body, endpoint) => {
    const customer = window.promoCustomer
      ? {
        customer_id: `${window.promoCustomer.id}`,
        email: window.promoCustomer.email,
      }
      : {};
    const payload = { ...body, customer };
    try {
      const response = await fetch(`${baseUrl}/${endpoint}`, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      return response.json();
    } catch (ex) {
      return { status: "error" };
    }
  };

  const processCheckout = async (details) => {
    const { cart } = details;
    if (!cart?.items?.length) {
      return;
    }

    const payload = {
      items: cart.items.map((item) => ({ sku: item.sku, quantity: item.quantity, properties: item.properties })),
    };

    const json = await request(payload, endpoints.checkout);
    const { data } = json;

    const redirect = data?.checkoutUrl ? data.checkoutUrl : "/checkout"
    
    setTimeout(function () {
      document.location.href = redirect;
    }, 250);
  };

  const updateCart = async (details) => {
    const { cart } = details;

    if (!cart?.items?.length) {
      return;
    }

    const payload = {
      items: cart.items.map((item) => ({ sku: item.sku, quantity: item.quantity })),
    };

    const json = await request(payload, endpoints.updateCart);
    const { data } = json;

    updateMainCart(data, cart);
    updateCartBubble(data, cart);
  };

  const updateMainCart = (promo, cart) => {
    const promoItems = promo?.items;
    const promoTotal = promo?.total;

    if (!promoItems) {
      return;
    }

    promoItems.map((promoItem) => {
      const variantId = promoItem.variant_id;
      const carItemSelector = `.promo-cart-${variantId}`;
      const discounted = promoItem.elements.length > 0;

      const messagesTemplate = discounted
        ? `
        <span class="promo-badges">
          ${promoItem.elements.map((ele) => `<span class="promo-badge mint promo-${ele.description.toLowerCase().split(' ').join('-')}">${ele.description}</span>`)}
        </span>
        `
        : "";

      const itemPriceTemplate = discounted
        ? `
        <del>
          <span class="amount fs-medium ">$${(promoItem.price / 100).toFixed(2)}</span>
        </del>
        <span class="amount fs-medium fw-bold">$${(promoItem.final_price / 100).toFixed(2)}</span>
        `
        : `
        <span class="amount fs-medium fw-bold">$${(promoItem.price / 100).toFixed(2)}</span>
        `;

      const itemTotalPriceTemplate = discounted
        ? `
        <span class="price">
          <del>
            <span class="amount">$${(promoItem.line_price / 100).toFixed(2)}</span>
          </del>
          <ins>
            <span class="amount fs-large fw-bold">$${(promoItem.final_line_price / 100).toFixed(2)}</span>
          </ins>
        </span>
        <div class="loading-overlay">
          <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="spinner-path" fill="none" stroke-width="6" cx="33" cy="33" r="30" stroke="var(--color-accent)"></circle>
          </svg>
        </div>
        `
        : `
        <span class="price">
          <ins>
            <span class="amount fs-large fw-bold">$${(promoItem.line_price / 100).toFixed(2)}</span>
          </ins>
        </span>
        <div class="loading-overlay">
          <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="spinner-path" fill="none" stroke-width="6" cx="33" cy="33" r="30" stroke="var(--color-accent)"></circle>
          </svg>
        </div>
        `;

      $("#Cart").find(carItemSelector).find(".promo-cart-badge").append(messagesTemplate);
      $("#Cart").find(carItemSelector).find(".promo-cart-unit-price").html(itemPriceTemplate);
      $("#Cart").find(carItemSelector).find(".promo-cart-item-subtotal").html(itemTotalPriceTemplate);
      $("#Cart").find(carItemSelector).removeClass("loading");
    });

    const cartPromoDiscounts = promoItems.reduce((result, item) => {
      for (const element of item.elements) {
        const uniqCode = `${element.campaign.code}_${element.code}`;
        if (result[uniqCode]) {
          result[uniqCode].amount += element.amount;
        } else {
          result[uniqCode] = {
            description: element.description,
            amount: element.amount,
          };
        }
      }
      return result;
    }, {});

    const originalCartTotalPrice = cart.original_total_price;
    const totalDiscounted = originalCartTotalPrice - promoTotal;

    const cartPromoDiscountsTemplate = Object.values(cartPromoDiscounts).map(
      (item) => `
      <tr class="cart-discount fs-small">
        <th>${item.description}</th>
        <td>
          <span class="price">
            <span class="amount">-$${(item.amount / 100).toFixed(2)}</span>
          </span>
        </td>
      </tr>
      `
    );

    const totalDiscountedPriceTemplate = `
      <th><h4>Discounts</h4></th>
      <td>-$${(totalDiscounted / 100).toFixed(2)}</td>
      `;
    const cartSubtotalPriceTemplate = `
      <span class="amount fs-large fw-bold">$${(promoTotal / 100).toFixed(2)}</span>
      `;

    $("#Cart").find(".promo-cart-discount-price").html(totalDiscountedPriceTemplate);
    $("#Cart").find(".cart-discount").remove();
    // $("#Cart").find(".promo-cart-discount-price").after(cartPromoDiscountsTemplate);
    $("#Cart").find(".cart-subtotal").find(".price").html(cartSubtotalPriceTemplate);
  };

  const updateCartBubble = (promo, cart) => {
    const promoItems = promo?.items;
    const promoTotal = promo?.total;

    if (!promoItems) {
      return;
    }

    promoItems.map((promoItem) => {
      const variantId = promoItem.variant_id;
      const carItemSelector = `.promo-cart-drawer-${variantId}`;
      const discounted = promoItem.elements.length > 0;

      const messagesTemplate = discounted
        ? promoItem.elements.map((ele) => `<span class="badge mint promo-${ele.description.toLowerCase().split(' ').join('-')}">${ele.description}</span>`)
        : "";

      const itemPriceTemplate = discounted
        ? `
        <div class="price">
          <del>
            <span class="amount">$${(promoItem.price / 100).toFixed(2)}</span>
          </del>
          <span class="amount">$${(promoItem.final_price / 100).toFixed(2)}</span>
        </div>
        `
        : `
        <div class="price">
          <span class="amount">$${(promoItem.price / 100).toFixed(2)}</span>
        </div>
      `;

      $("#Cart-Drawer").find(carItemSelector).find(".promo-cart-badge").append(messagesTemplate);
      $("#Cart-Drawer").find(carItemSelector).find(".promo-cart-unit-price").html(itemPriceTemplate);
      $("#Cart-Drawer").find(carItemSelector).removeClass("thb-loading");
    });

    const originalCartTotalPrice = cart.original_total_price;
    const totalDiscounted = originalCartTotalPrice - promoTotal;

    const totalDiscountedPriceTemplate = `
      <th>Discounts</th>
      <td>-$${(totalDiscounted / 100).toFixed(2)}</td>
      `;
    const cartSubtotalPriceTemplate = `$${(promoTotal / 100).toFixed(2)}`;

    $("#Cart-Drawer").find(".promo-cart-discount-price").html(totalDiscountedPriceTemplate);
    $("#Cart-Drawer").find(".cart-subtotal").find(".amount").html(cartSubtotalPriceTemplate);
  };

  const updateMarkdown = async (details) => {
    const { item } = details;
    const sku = item.sku || item.selected_or_first_available_variant.sku;
    const price = item.price;
    const itemSelector = `.promo-product-info-${sku}`;

    const json = await request(
      {
        items: [
          {
            sku: `${sku}`,
            price,
          },
        ],
      },
      endpoints.markdown
    );
    const { data } = json;

    renderProductMarkdown(data.items[0], itemSelector);
  };

  const renderProductMarkdown = (item, itemSelector) => {
    const { price, markdown_price } = convertItem(item);
    const isMarkdownPricing = !!markdown_price && price !== markdown_price;
    const isMembersPricing = item.elements.find((ele) => ele.members_only);
    const promoItemMessages = item.elements.map((ele) => `<span class="badge mint promo-${ele.description.toLowerCase().split(' ').join('-')}">${ele.description}</span>`);
    const promoBadgesTemplate =
      !isMembersPricing && isMarkdownPricing
        ? promoItemMessages
        : `${$(itemSelector).find(`.badges`).html()}${promoItemMessages}`;

    const promoItemPriceTemplate = !isMarkdownPricing
      ? $(itemSelector).find(`.product-price-container .price`).html()
      : !isMembersPricing
        ? `
      <del>
        <span class="amount">
          ${price}
        </span>
      </del>
      <ins>
        <span class="amount">${markdown_price}</span>
      </ins>
      `
        : `
      ${$(itemSelector).find(`.product-price-container .price`).html()}
      <ins>
        <span class="amount mint-dark">&nbsp|&nbsp${markdown_price} Members</span>
      </ins>
    
    `;

    // empty badges elements before appending
    $(itemSelector).find(`.badges`).empty();

    $(itemSelector).find(`.badges`).append(promoBadgesTemplate);
    $(itemSelector).find(`.product-price-container .price`).html(promoItemPriceTemplate);
  };

  const updateRecommendation = async (details) => {
    const { sku, price } = details;
    const json = await request(
      {
        items: [
          {
            sku: `${sku}`,
            price,
          },
        ],
      },
      endpoints.markdown
    );
    const { data } = json;

    renderProductCardMarkdown(data.items[0], `.promo-product-card-${sku}`);
    renderProductCardSmallMarkdown(data.items[0], `.promo-product-card-item-${sku}`);
  };

  const renderProductCardMarkdown = (item, itemSelector) => {
    const { price, markdown_price } = convertItem(item);
    const isMarkdownPricing = !!markdown_price && price !== markdown_price;
    const promoItemMessages = item.elements
      .filter((ele) => !!ele.markdown)
      .map((ele) => `<span class="promo-badge mint promo-${ele.description.toLowerCase().split(' ').join('-')}">${ele.description}</span>`);

    const promoItemPriceTemplate = isMarkdownPricing
      ? `
      <del>
        <span class="amount">
          ${price}
        </span>
      </del>
      <ins>
        <span class="amount">${markdown_price}</span>
      </ins>
    `
      : $(itemSelector).find(`.product-card-info .price`).html();

    $(itemSelector).find(`.badges`).html(promoItemMessages);
    $(itemSelector).find(`.product-card-info .price`).html(promoItemPriceTemplate);
  };

  const renderProductCardSmallMarkdown = (item, itemSelector) => {
    const { price, markdown_price } = convertItem(item);
    const isMarkdownPricing = !!markdown_price && price !== markdown_price;
    const promoItemPriceTemplate = isMarkdownPricing
      ? `
      <del>
        <span class="amount">
          ${price}
        </span>
      </del>
      <ins>
        <span class="amount">${markdown_price}</span>
      </ins>
    `
      : $(itemSelector).find(`.price`).html();

    $(itemSelector).find(`.price`).html(promoItemPriceTemplate);
  };

  const convertItem = (item) => {
    const price = `$${item.price / 100}`;
    const markdown_price = item.markdown_price ? `$${item.markdown_price / 100}` : item.markdown_price;

    return {
      price,
      markdown_price,
    };
  };

  window.addEventListener("cartUpdated", async (e) => {
    if (e.detail?.cart) {
      await updateCart(e.detail);
    }
  });

  window.addEventListener("checkoutClicked", async (e) => {
    if (e.detail?.cart) {
      await processCheckout(e.detail);
    }
  });

  window.addEventListener("productLoaded", async (e) => {
    if (e.detail?.item) {
      await updateMarkdown(e.detail);
    }
  });

  window.addEventListener("recommendationLoaded", async (e) => {
    if (e.detail?.sku && e.detail?.price) {
      await updateRecommendation(e.detail);
    }
  });
})();
